import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsPage() {
  return <div className="min-h-screen bg-[#F8FAFC] flex flex-col font-sans text-[#0F172A]" data-id="element-1043">
      {/* Simple Header */}
      <header className="bg-white border-b border-slate-100 sticky top-0 z-50" data-id="element-1044">
        <div className="container mx-auto px-6 max-w-6xl h-20 flex items-center justify-between" data-id="element-1045">
          <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-[#0F172A] no-underline" data-id="element-1046">
            <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip Logo" className="w-8 h-8 object-contain" data-id="element-1047" />
            CorkShip
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-[#64748B] hover:text-[#0284C7] transition-colors" data-id="element-1048">
            <ArrowLeft size={16} data-id="element-1049" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow py-16 px-6" data-id="element-1050">
        <article className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12" data-id="element-1051">
          {/* Page Header */}
          <header className="mb-12 text-center md:text-left border-b border-slate-100 pb-8" data-id="element-1052">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#0F172A] mb-4" data-id="element-1053">
              Terms of Service
            </h1>
            <p className="text-[#64748B] text-lg" data-id="element-1054">Last updated: January 2026</p>
          </header>

          {/* Content Body */}
          <div className="max-w-none" data-id="element-1055">
            <section className="mb-12" data-id="element-1056">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1057">
                1. Introduction
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1058">
                Welcome to CorkShip. These Terms of Service ("Terms") govern
                your use of the CorkShip application ("App", "Service") provided
                by CorkShip ("we", "our", "us").
              </p>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1059">
                By installing or using CorkShip, you agree to these Terms. If
                you do not agree, please do not use the Service.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1060" />

            <section className="mb-12" data-id="element-1061">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1062">
                2. Description of Service
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1063">
                CorkShip is an application that helps Australian wineries manage
                shipping fulfilment through Australia Post's eParcel service.
                The Service includes:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1064">
                <li data-id="element-1065">Smart parcel assignment based on bottle quantities</li>
                <li data-id="element-1066">
                  Shipping label generation via Australia Post eParcel API
                </li>
                <li data-id="element-1067">Manifest creation and management</li>
                <li data-id="element-1068">Address and postcode validation</li>
                <li data-id="element-1069">Order tracking synchronisation</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1070" />

            <section className="mb-12" data-id="element-1071">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1072">
                3. Eligibility
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1073">
                To use CorkShip, you must:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1074">
                <li data-id="element-1075">Have an active Shopify or Commerce7 store</li>
                <li data-id="element-1076">Have a valid Australia Post eParcel business account</li>
                <li data-id="element-1077">Be located in or shipping from Australia</li>
                <li data-id="element-1078">Be at least 18 years of age</li>
                <li data-id="element-1079">Have the authority to bind your business to these Terms</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1080" />

            <section className="mb-12" data-id="element-1081">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1082">
                4. Account and Credentials
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1083">
                Your Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1084">
                <li data-id="element-1085">
                  You are responsible for maintaining the security of your store
                  and Australia Post credentials
                </li>
                <li data-id="element-1086">
                  You must provide accurate Australia Post account information
                </li>
                <li data-id="element-1087">
                  You must not share your account access with unauthorised
                  parties
                </li>
                <li data-id="element-1088">
                  You are responsible for all activity that occurs through your
                  account
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1089">
                Our Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1090">
                <li data-id="element-1091">
                  We encrypt and securely store your Australia Post credentials
                </li>
                <li data-id="element-1092">
                  We do not access your credentials except to provide the
                  Service
                </li>
                <li data-id="element-1093">We isolate your data from other users of the Service</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1094" />

            <section className="mb-12" data-id="element-1095">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1096">
                5. Acceptable Use
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1097">
                You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1098">
                <li data-id="element-1099">Use the Service for any unlawful purpose</li>
                <li data-id="element-1100">Attempt to gain unauthorised access to our systems</li>
                <li data-id="element-1101">Interfere with or disrupt the Service</li>
                <li data-id="element-1102">Use the Service to ship prohibited items</li>
                <li data-id="element-1103">
                  Reverse engineer or attempt to extract the source code of the
                  Service
                </li>
                <li data-id="element-1104">
                  Resell or redistribute the Service without our permission
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1105" />

            <section className="mb-12" data-id="element-1106">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1107">
                6. Fees and Payment
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1108">
                Subscription Fees
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1109">
                <li data-id="element-1110">CorkShip is offered at $14.99 USD per month</li>
                <li data-id="element-1111">
                  Fees are billed monthly through your platform's billing system
                </li>
                <li data-id="element-1112">All fees are non-refundable except as required by law</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1113">
                Free Trial
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1114">
                <li data-id="element-1115">New users receive a 14-day free trial</li>
                <li data-id="element-1116">No credit card is required to start the trial</li>
                <li data-id="element-1117">You will be notified before the trial ends</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1118">
                Price Changes
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1119">
                <li data-id="element-1120">We may change our fees with 30 days notice</li>
                <li data-id="element-1121">
                  Continued use after a price change constitutes acceptance
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1122" />

            <section className="mb-12" data-id="element-1123">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1124">
                7. Australia Post Integration
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1125">
                Your Australia Post Account
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1126">
                <li data-id="element-1127">
                  You must have your own Australia Post eParcel business account
                </li>
                <li data-id="element-1128">
                  CorkShip connects to Australia Post using your credentials
                </li>
                <li data-id="element-1129">
                  Australia Post's terms and conditions apply to all shipments
                </li>
                <li data-id="element-1130">
                  Shipping rates are determined by Australia Post, not CorkShip
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1131">
                Service Limitations
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1132">
                <li data-id="element-1133">CorkShip relies on Australia Post's API availability</li>
                <li data-id="element-1134">
                  We are not responsible for Australia Post service outages or
                  delays
                </li>
                <li data-id="element-1135">
                  Label generation requires a valid Australia Post connection
                </li>
                <li data-id="element-1136">Tracking information is provided by Australia Post</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1137" />

            <section className="mb-12" data-id="element-1138">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1139">
                8. Shipping Responsibilities
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1140">
                Your Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1141">
                <li data-id="element-1142">Ensuring orders are packed correctly and safely</li>
                <li data-id="element-1143">Verifying shipping addresses before generating labels</li>
                <li data-id="element-1144">Complying with Australia Post's packaging requirements</li>
                <li data-id="element-1145">
                  Complying with wine shipping regulations (including age
                  verification)
                </li>
                <li data-id="element-1146">Handing parcels to Australia Post for delivery</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1147">
                Our Responsibilities
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1148">
                <li data-id="element-1149">
                  Generating accurate shipping labels based on information you
                  provide
                </li>
                <li data-id="element-1150">Syncing tracking numbers back to your store</li>
                <li data-id="element-1151">Providing tools to manage your shipping workflow</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1152">
                What We Don't Control
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1153">
                <li data-id="element-1154">
                  Actual delivery of parcels (this is Australia Post's
                  responsibility)
                </li>
                <li data-id="element-1155">Delivery timeframes</li>
                <li data-id="element-1156">
                  Lost or damaged parcels (claims must be made with Australia
                  Post)
                </li>
                <li data-id="element-1157">Australia Post service disruptions</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1158" />

            <section className="mb-12" data-id="element-1159">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1160">
                9. Intellectual Property
              </h2>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1161">
                <li data-id="element-1162">
                  CorkShip and its original content, features, and functionality
                  are owned by us
                </li>
                <li data-id="element-1163">
                  The CorkShip name, logo, and branding are our trademarks
                </li>
                <li data-id="element-1164">You may not copy, modify, or distribute our software</li>
                <li data-id="element-1165">
                  Your data remains yours — we claim no ownership of your order
                  or customer data
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1166" />

            <section className="mb-12" data-id="element-1167">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1168">
                10. Privacy
              </h2>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-1169">
                Your privacy is important to us. Please review our{' '}
                <Link to="/privacy" className="text-[#0284C7] hover:underline" data-id="element-1170">
                  Privacy Policy
                </Link>{' '}
                which explains how we collect, use, and protect your
                information.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1171" />

            <section className="mb-12" data-id="element-1172">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1173">
                11. Service Availability
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1174">
                Uptime
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1175">
                <li data-id="element-1176">
                  We strive to maintain high availability but do not guarantee
                  100% uptime
                </li>
                <li data-id="element-1177">
                  We may perform maintenance that temporarily affects
                  availability
                </li>
                <li data-id="element-1178">
                  We will try to notify you of planned maintenance in advance
                </li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1179">
                Changes to the Service
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1180">
                <li data-id="element-1181">
                  We may modify or discontinue features with reasonable notice
                </li>
                <li data-id="element-1182">We may release updates and new features at any time</li>
                <li data-id="element-1183">
                  Significant changes will be communicated via email or in-app
                  notification
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1184" />

            <section className="mb-12" data-id="element-1185">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1186">
                12. Limitation of Liability
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1187">
                To the maximum extent permitted by law:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1188">
                <li data-id="element-1189">
                  CorkShip is provided "as is" without warranties of any kind
                </li>
                <li data-id="element-1190">
                  We are not liable for any indirect, incidental, or
                  consequential damages
                </li>
                <li data-id="element-1191">
                  Our total liability is limited to the fees you paid in the 12
                  months prior to the claim
                </li>
                <li data-id="element-1192">
                  We are not liable for issues caused by Australia Post, your
                  platform, or your own actions
                </li>
              </ul>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-1193">
                This does not affect any rights you have under Australian
                Consumer Law that cannot be excluded.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1194" />

            <section className="mb-12" data-id="element-1195">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1196">
                13. Indemnification
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1197">
                You agree to indemnify and hold us harmless from any claims,
                damages, or expenses arising from:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1198">
                <li data-id="element-1199">Your use of the Service</li>
                <li data-id="element-1200">Your violation of these Terms</li>
                <li data-id="element-1201">Your violation of any third-party rights</li>
                <li data-id="element-1202">Any dispute between you and your customers</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1203" />

            <section className="mb-12" data-id="element-1204">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1205">
                14. Termination
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1206">
                By You
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1207">
                <li data-id="element-1208">
                  You may stop using CorkShip at any time by uninstalling the
                  app from your store
                </li>
                <li data-id="element-1209">No refunds are provided for partial billing periods</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1210">
                By Us
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1211">
                We may suspend or terminate your access if:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1212">
                <li data-id="element-1213">You violate these Terms</li>
                <li data-id="element-1214">You fail to pay fees when due</li>
                <li data-id="element-1215">Your use poses a security risk</li>
                <li data-id="element-1216">Required by law</li>
              </ul>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1217">
                Effect of Termination
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1218">
                <li data-id="element-1219">Your data will be deleted within 30 days of termination</li>
                <li data-id="element-1220">You may request a data export before uninstalling</li>
                <li data-id="element-1221">Any outstanding fees remain payable</li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1222" />

            <section className="mb-12" data-id="element-1223">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1224">
                15. Dispute Resolution
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1225">
                Governing Law
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1226">
                These Terms are governed by the laws of Victoria, Australia.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1227">
                Resolution Process
              </h3>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1228">
                <li data-id="element-1229">
                  Contact us first at{' '}
                  <a href="mailto:support@corkship.com.au" className="text-[#0284C7] hover:underline" data-id="element-1230">
                    support@corkship.com.au
                  </a>{' '}
                  to resolve any issues
                </li>
                <li data-id="element-1231">
                  If we cannot resolve the dispute informally, either party may
                  pursue legal remedies
                </li>
                <li data-id="element-1232">
                  Any legal proceedings shall be conducted in the courts of
                  Victoria, Australia
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1233" />

            <section className="mb-12" data-id="element-1234">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-8" data-id="element-1235">
                16. General Provisions
              </h2>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1236">
                Entire Agreement
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1237">
                These Terms, together with our Privacy Policy, constitute the
                entire agreement between you and CorkShip.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1238">
                Severability
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1239">
                If any provision of these Terms is found unenforceable, the
                remaining provisions remain in effect.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1240">
                No Waiver
              </h3>
              <p className="text-[#0F172A] leading-[1.8] mb-6" data-id="element-1241">
                Our failure to enforce any right or provision does not
                constitute a waiver.
              </p>

              <h3 className="font-heading font-bold text-lg text-[#0F172A] mt-8 mb-4" data-id="element-1242">
                Assignment
              </h3>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-1243">
                You may not assign your rights under these Terms. We may assign
                our rights to a successor or acquirer.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1244" />

            <section className="mb-12" data-id="element-1245">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1246">
                17. Changes to These Terms
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1247">
                We may update these Terms from time to time. We will notify you
                of material changes by:
              </p>
              <ul className="list-disc pl-6 space-y-3 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1248">
                <li data-id="element-1249">Posting a notice in the app</li>
                <li data-id="element-1250">Sending an email to your store email</li>
                <li data-id="element-1251">Updating the "Last updated" date</li>
              </ul>
              <p className="text-[#0F172A] leading-[1.8]" data-id="element-1252">
                Continued use after changes constitutes acceptance of the new
                Terms.
              </p>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1253" />

            <section className="mb-12" data-id="element-1254">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1255">
                18. Contact Us
              </h2>
              <p className="text-[#0F172A] leading-[1.8] mb-4" data-id="element-1256">
                If you have questions about these Terms:
              </p>
              <ul className="list-none space-y-2 mb-6 text-[#0F172A] leading-[1.8]" data-id="element-1257">
                <li data-id="element-1258">
                  <strong data-id="element-1259">Email:</strong>{' '}
                  <a href="mailto:support@corkship.com.au" className="text-[#0284C7] hover:underline" data-id="element-1260">
                    support@corkship.com.au
                  </a>
                </li>
                <li data-id="element-1261">
                  <strong data-id="element-1262">Address:</strong> CorkShip Melbourne, Victoria
                  Australia
                </li>
              </ul>
            </section>

            <hr className="my-12 border-slate-200" data-id="element-1263" />

            <section data-id="element-1264">
              <h2 className="font-heading font-bold text-2xl text-[#0F172A] mb-6" data-id="element-1265">
                Summary
              </h2>
              <div className="overflow-x-auto" data-id="element-1266">
                <table className="w-full text-left border-collapse mt-6" data-id="element-1267">
                  <thead data-id="element-1268">
                    <tr className="bg-slate-50 border-b border-slate-200" data-id="element-1269">
                      <th className="p-4 font-bold text-[#0F172A]" data-id="element-1270">Topic</th>
                      <th className="p-4 font-bold text-[#0F172A]" data-id="element-1271">
                        Key Points
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm" data-id="element-1272">
                    <tr className="border-b border-slate-100" data-id="element-1273">
                      <td className="p-4" data-id="element-1274">What you get</td>
                      <td className="p-4" data-id="element-1275">
                        Shipping label generation, parcel assignment, manifest
                        management
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-1276">
                      <td className="p-4" data-id="element-1277">What you need</td>
                      <td className="p-4" data-id="element-1278">
                        Shopify or Commerce7 store + Australia Post eParcel
                        account
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-1279">
                      <td className="p-4" data-id="element-1280">Cost</td>
                      <td className="p-4" data-id="element-1281">
                        $14.99 USD/month after 14-day free trial
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-1282">
                      <td className="p-4" data-id="element-1283">Your data</td>
                      <td className="p-4" data-id="element-1284">
                        Remains yours, deleted within 30 days of uninstall
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-1285">
                      <td className="p-4" data-id="element-1286">Australia Post</td>
                      <td className="p-4" data-id="element-1287">
                        Their terms apply to actual shipping; we just generate
                        labels
                      </td>
                    </tr>
                    <tr className="border-b border-slate-100" data-id="element-1288">
                      <td className="p-4" data-id="element-1289">Liability</td>
                      <td className="p-4" data-id="element-1290">
                        Limited to fees paid; we don't control delivery
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </article>
      </main>

      {/* Footer */}
      <Footer data-id="element-1291" />
    </div>;
}